import React from 'react';
import { Image } from 'antd';

/** Image attachments that carry a preview_url: thumbnails, click to open the full image (arrows between them). */
const AttachmentImages = ({ items }) => {
    const imgs = (items || []).filter((a) => a.preview_url);
    if (!imgs.length) return null;
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
            <Image.PreviewGroup>
                {imgs.map((a) => (
                    <Image key={a.id} src={a.preview_url} alt={a.filename} title={a.filename} width={120} height={90}
                        style={{ objectFit: 'cover', borderRadius: 6, border: '1px solid rgba(128,128,128,0.25)' }} />
                ))}
            </Image.PreviewGroup>
        </div>
    );
};

export default AttachmentImages;
